import { render } from "./ItemRow.vue?vue&type=template&id=f814f422&ts=true"
import script from "./ItemRow.vue?vue&type=script&lang=ts"
export * from "./ItemRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__